import React from "react";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import { TextField, IconButton } from "@components";
import IconTrash from "@assets/icon_trash.svg";
import IconDrag from "@assets/icon-drag.svg";
import styles from "./AIToolsList.module.scss";
export function AIToolsList({ aiTools, onEdit, readOnly, showValidation = false, validationErrors = {}, }) {
    const handleDragEnd = (result) => {
        if (!result.destination || readOnly) {
            return;
        }
        if (result.destination.index === result.source.index) {
            return;
        }
        const newAITools = [...aiTools];
        const [removed] = newAITools.splice(result.source.index, 1);
        newAITools.splice(result.destination.index, 0, removed);
        onEdit(newAITools);
    };
    const handleNameChange = (index, name) => {
        const updatedTools = aiTools.map((tool, i) => (i === index ? Object.assign(Object.assign({}, tool), { name }) : tool));
        onEdit(updatedTools);
    };
    const handleDescriptionChange = (index, description) => {
        const updatedTools = aiTools.map((tool, i) => (i === index ? Object.assign(Object.assign({}, tool), { description }) : tool));
        onEdit(updatedTools);
    };
    const handleRemove = (index) => {
        if (aiTools.length > 1) {
            const updatedTools = aiTools.filter((_, i) => i !== index);
            onEdit(updatedTools);
        }
    };
    return (React.createElement(DragDropContext, { onDragEnd: handleDragEnd },
        React.createElement(Droppable, { droppableId: "ai-tools-list", type: "ai-tools" }, (provided) => (React.createElement("div", Object.assign({}, provided.droppableProps, { ref: provided.innerRef, className: styles.container }),
            aiTools.map((tool, index) => (React.createElement(Draggable, { key: tool.id, draggableId: tool.id, index: index, isDragDisabled: readOnly || aiTools.length < 2 }, (dragProvided, snapshot) => (React.createElement("div", Object.assign({ ref: dragProvided.innerRef }, dragProvided.draggableProps, { className: `${styles.item} ${snapshot.isDragging ? styles.isDragging : ""}` }),
                React.createElement("div", Object.assign({ className: styles.dragIconContainer }, dragProvided.dragHandleProps),
                    React.createElement(IconDrag, { className: `${styles.drag} ${readOnly || aiTools.length < 2 ? styles.dragDisabled : ""}` })),
                React.createElement("div", { className: styles.fields },
                    React.createElement("div", { className: styles.nameField },
                        React.createElement(TextField, { value: tool.name, onChange: ({ target: { value } }) => handleNameChange(index, value), placeholder: "AI Tool Name", disabled: readOnly, hasError: showValidation && validationErrors[index] === "name" })),
                    React.createElement("div", { className: styles.descriptionField },
                        React.createElement(TextField, { value: tool.description, onChange: ({ target: { value } }) => handleDescriptionChange(index, value), placeholder: "Description", disabled: readOnly, hasError: showValidation && validationErrors[index] === "description", maxLength: 100, isLimitVisible: true }))),
                React.createElement(IconButton, { color: "secondary", onClick: () => handleRemove(index), icon: React.createElement(IconTrash, null), disabled: readOnly ||
                        (aiTools.length === 1 &&
                            aiTools[0].name === "" &&
                            aiTools[0].description === ""), title: "Remove" })))))),
            provided.placeholder)))));
}
